
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingLaborGrid extends Serenity.EntityGrid<SKURepricingLaborRow, any> {
        protected getColumnsKey() { return 'Inventory.SKURepricingLabor'; }
        protected getDialogType() { return SKURepricingLaborDialog; }
        protected getIdProperty() { return SKURepricingLaborRow.idProperty; }
        protected getInsertPermission() { return SKURepricingLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return SKURepricingLaborRow.localTextPrefix; }
        protected getService() { return SKURepricingLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}